// MARK://dhk8/storefront/components/BrandHeader
// Topbar pública del storefront — muestra el logo + nombre del tenant si lo
// tenemos (vía useTenantBranding); fallback al wordmark NintaiGO.
//
// Cuando logoUrl es null, renderizamos un wordmark textual estilizado
// "Nintai GO" replicando la tipografía de marca (display + tracking-tight).

import type { TenantBranding } from '../lib/branding.js'

interface BrandHeaderProps {
  branding: TenantBranding
  /** Slot derecho — carrito en el catálogo, vacío en ReservarPage. */
  right?: React.ReactNode
  /** Páginas de plataforma (fila/reservas/consulta): el header SIEMPRE es
   *  NintaiGO (marca de la plataforma), nunca el del negocio. La identidad del
   *  negocio va dentro del contenido (<BusinessIdentity/>). */
  platformBrand?: boolean
}

export default function BrandHeader({ branding, right, platformBrand }: BrandHeaderProps) {
  const hasLogo = !platformBrand && !!branding.logoUrl
  const showCustomName =
    !platformBrand && branding.displayName && branding.displayName.trim().toLowerCase() !== 'nintaigo'

  return (
    <header className="sf-topbar">
      <div className="sf-topbar__brand">
        {hasLogo ? (
          <img
            src={branding.logoUrl!}
            alt={branding.displayName}
            className="sf-topbar__logo"
            loading="eager"
            decoding="async"
          />
        ) : (
          <span className="sf-topbar__wordmark" aria-label="NintaiGO">
            Nintai<span className="sf-topbar__wordmark--accent">GO</span>
          </span>
        )}
        {showCustomName && <span className="sf-topbar__tenant">· {branding.displayName}</span>}
      </div>
      {right ?? null}
    </header>
  )
}
